import React from 'react';
import { matchPath, useLocation } from 'react-router';
import {
  List,
  Box,
  makeStyles,
} from '@material-ui/core';

import { Tab } from 'src/types';
import NavItem from './NavItem';

/*
Sidebar navigation component. Feed it a list of tabs in the following shape...
tabs = [
  {
    route: '/dashboard',
    component: EngagementDashboard,
    label: 'Dashboard',
    icon: Sliders
  },
  {
    component: EngagementDashboard,
    label: 'Dashboard',
    icon: Sliders,
    items: [
      {
        route: '/dashboard',
        component: EngagementDashboard,
        label: 'Dashboard',
        icon: Sliders
      },
    ]
  },
]

Either route and/or items are required for each tab.
If a route is passed in, a corresponding component will be expected to render for that route
If items are passed in, a list of tabs will be rendered under the parent tab in an accordian fashion
If both a route and items are passed in, the items will be rendered underneath the parent tab but the parent will have its own render component
icon and info are both optional

TODO - headers and dividers
 */

const useStyles = makeStyles((theme) => ({
  list: {
    display: 'block',
    paddingTop: 0,
    paddingBottom: 0,
  },
}));

function renderNavItems({
  items,
  pathname,
  depth
}: any) {
  return (
    <List>
      {items.reduce(
        (acc: any, item: any) => reduceChildRoutes({
          acc, item, pathname, depth
        }),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({
  acc,
  pathname,
  item,
  depth = 0
}: any) {
  const key = item.label + depth;
  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        key={key}
        info={item.info}
        open={Boolean(open)}
        label={item.label}
        action={item.action}
        exact={item.exact}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items
        })}
      </NavItem>
    );
  } else if (item.customNavComponent) {
    acc.push(<item.customNavComponent key={key} />);
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.route}
        icon={item.icon}
        key={key}
        info={item.info}
        label={item.label}
        exact={item.exact}
      />
    );
  }

  return acc;
}


const SideNav = ({ tabs }: { tabs: Tab[] }) => {
  const { pathname } = useLocation();

  return (
    <Box p={2}>
      {
        renderNavItems({
          depth: 0,
          items: tabs,
          pathname,
        })
      }
    </Box>
  );
};

export default SideNav;
